import { Page } from 'layouts/Page';
import { FC } from 'react';
import { GeneralSettings } from 'components/GeneralSettings';

export const GeneralSettingsPage: FC = () => {
	return (
		<Page title="General Settings – EAS Dashboard">
			<GeneralSettings />
		</Page>
	);
};
